export const basePageCall = (callback) => {
  try {
    if (typeof window === 'undefined') return;
    const parentWindow = window.parent;
    if (!parentWindow || parentWindow === window) return;
    callback(parentWindow);
  } catch (error) {
    void error;
  }
};

export const trackAnalyticsEvents = (event) => {
  basePageCall((parentWindow) => {
    let analyticsTracked = false;

    try {
      if (Array.isArray(parentWindow.dataLayer)) {
        parentWindow.dataLayer.push({ event });
        analyticsTracked = true;
      }
    } catch (error) {
      console.warn('[tracking] dataLayer access failed', error);
    }

    if (analyticsTracked) return;

    try {
      if (typeof parentWindow.postMessage === 'function') {
        parentWindow.postMessage(
          {
            source: 'vogue-street-style',
            type: 'analytics-event',
            event
          },
          '*'
        );
      }
    } catch (error) {
      console.warn('[tracking] analytics postMessage failed', error);
    }
  });
};

export const trackEmitReadyEvent = () => {
  basePageCall((parentWindow) => {
    let emittedFromCnBus = false;

    try {
      const cnBus = parentWindow.cnBus;

      if (cnBus && typeof cnBus.emit === 'function') {
        cnBus.emit('react.ready');
        emittedFromCnBus = true;
      }
    } catch (error) {
      console.warn('[tracking] cnBus access failed', error);
    }

    if (emittedFromCnBus) return;

    try {
      if (typeof parentWindow.postMessage === 'function') {
        parentWindow.postMessage(
          {
            source: 'vogue-street-style',
            type: 'react.ready'
          },
          '*'
        );
      }
    } catch (error) {
      console.warn('[tracking] ready postMessage failed', error);
    }
  });
};
